module.exports = __webpack_public_path__ + "img/packet-black.cdd96d23.svg";